(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('modalWindow', modalWindow);

    /* @ngInject */
    function modalWindow($location) {
        var directive = {
            bindToController: true,
            transclude: true,
            templateUrl: 'modal-window.tpl',
            controller: modalWindowController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.modalClose = function() {
                element.find('.overlay').removeClass('active');
                if (scope.$root.modalContent == 'info-modal') {  // dirty crutch!!!!
                    scope.$apply(function() {
                        scope.$root.modalContent = '';
                    });
                } else {
                    scope.$root.modalContent = '';
                }
                if (angular.isDefined(scope.$root.stats.requiredLogin)) {
                    $location.url('/');
                    // $location.url('/?cancel-reset-pass=1');
                    window.location.href = '/?cancel-reset-pass=1';
                }
            };
        }

    }
    /* @ngInject */
    function modalWindowController ($rootScope, $element, $scope) {
        $rootScope.modalContent = '';
        $rootScope.openModal = function(modal) {
            $element.find('.overlay').addClass('active');
            $rootScope.modalContent = modal;
            //$rootScope.chooseModal();
            //console.log($rootScope.modalContent);
            if ((modal == 'login-form') && angular.isDefined($rootScope.stats.requiredLogin)) {
                $scope.vm.smallerPopup = true;
            }
            if ((modal == 'submit-modal')) {
                $scope.vm.sbmtModal = true;
            }
            if ((modal == 'subscribe-form')) {
                $scope.vm.subscribeForm = true;
            }
            if ((modal == 'info-modal')) {
                $scope.vm.infoModal = true;
            }
        };

        $rootScope.modalClose = function() {
            $scope.vm.modalClose();
        };

        $rootScope.chooseModal = function() {
            return $rootScope.modalContent;
            /*
            if($rootScope.modalContent == 'subscribe-form') {
                return 'subscribe-form';
            }
            if($rootScope.modalContent == 'login-form') {
                return 'login-form';
            }
            if($rootScope.modalContent == 'upload-media') {
                return 'upload-media';
            }
            if($rootScope.modalContent == 'submit-modal') {
                return 'submit-modal';
            }
            if($rootScope.modalContent == 'error-modal') {
                return 'error-modal';
            }
            */
        };
    }
})();